export enum UserAfterLoginRoute {
	PASSWORD = 'PASSWORD',
	PROFILE = 'PROFILE',
	COURSES = 'COURSES',
	APPLICATIONS = 'APPLICATIONS',
}
